import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addOrRemoveToFavourite, getFavorite } from '../../services/FavoriteAPI';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  loading: false,
  data: {},
  addedToFavorites: 0,
  isUpdating: false,
  updatingPropertyId: null,
  currentPage: 1,
  perPage: 10,
};

export const fetchFavoriteAction = createAsyncThunk('FETCH_FAVORITES', getFavorite);
export const addOrRemoveToFavouriteAction = createAsyncThunk('ADD_OR_REMOVE_FAV', addOrRemoveToFavourite);
export const favoriteSlice = createSlice({
  name: 'favorite',
  initialState,
  reducers: {
    updateFavoriteData: (state, action) => {
      state.data = { ...action.payload };
    },
    updateFavoriteCount: (state) => {
      state.addedToFavorites += 1;
    },
  },
  extraReducers: {
    [fetchFavoriteAction.pending]: (state, action) => {
      const { meta: { arg: { page = 1 } = {} } = {} } = action;
      return {
        ...state,
        loading: true,
        currentPage: page,
      };
    },
    [fetchFavoriteAction.fulfilled]: (state, action) => {
      const {
        meta: {
          arg: { isSmallScreen = false },
        },
      } = action;
      return {
        ...state,
        loading: false,
        data: isSmallScreen
          ? {
              ...state?.data,
              ...action?.payload,
              data: {
                ...state?.data?.data,
                ...action?.payload?.data,
                propertyList: [...state?.data?.data?.propertyList, ...action?.payload?.data?.propertyList],
              },
            }
          : action.payload,
      };
    },
    [fetchFavoriteAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
    [addOrRemoveToFavouriteAction.pending]: (state, action) => {
      return {
        ...state,
        isUpdating: true,
        updatingPropertyId: action?.meta?.arg?.propertyId,
      };
    },
    [addOrRemoveToFavouriteAction.fulfilled]: (state, action) => {
      let newData = [...(state?.data?.data?.propertyList || [])];
      if (state?.data?.data?.propertyList?.some((property) => property?.propertyId?.toString() === action?.payload?.toString())) {
        // we are removing favorite
        newData = newData.filter((property) => property?.propertyId?.toString() !== action?.payload?.toString());
      }
      return {
        ...state,
        isUpdating: false,
        updatingPropertyId: null,
        data: {
          ...state?.data,
          data: {
            ...state?.data?.data,
            propertyList: newData,
          },
        },
      };
    },
    [addOrRemoveToFavouriteAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        isUpdating: false,
        updatingPropertyId: null,
      };
    },
  },
});

export const { updateFavoriteData, updateFavoriteCount } = favoriteSlice.actions;
const { reducer } = favoriteSlice;

export default reducer;
